
import { createSlice } from '@reduxjs/toolkit';

const multiDepositSlice = createSlice({
    name: 'multiDepositSlice',
    initialState: {},
    reducers: {
       setMultiDeposits:(state,action) =>{
            state.solnId=action.payload.solutionId;
            state.last4=action.payload.last4;
        }
    },
});

export const {setMultiDeposits } = multiDepositSlice.actions;

export default multiDepositSlice.reducer;



